import * as React from "react"
import { SVGProps } from "react"
const CalendarPrevious = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={8} height={14.367} {...props}>
    <path
      fill="#647188"
      d="m2.414 7.184 5.293 5.431a1.045 1.045 0 0 1 0 1.451.982.982 0 0 1-1.414 0l-6-6.157a1.045 1.045 0 0 1 0-1.451l6-6.158a.982.982 0 0 1 1.414 0 1.045 1.045 0 0 1 0 1.451Z"
    />
  </svg>
)
export default CalendarPrevious
